module.exports = __webpack_public_path__ + "img/sms.c5352e57.png";